export enum ExecutionStateEnum {
  EXECUTED_AND_PLANNED = 'EXECUTED_AND_PLANNED',
  EXECUTED = 'EXECUTED',
  PLANNED = 'PLANNED',
}
